import { render, staticRenderFns } from "./DataRotationSetup.vue?vue&type=template&id=f52ffc76&"
import script from "./DataRotationSetup.vue?vue&type=script&lang=js&"
export * from "./DataRotationSetup.vue?vue&type=script&lang=js&"
import style0 from "./DataRotationSetup.vue?vue&type=style&index=0&id=f52ffc76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports